import React, { useEffect, useState } from "react";
import { getPartners } from "../api/api.js";
import ScrollTop from "./ScrollTop";
// import SideBox from "./SideBox.js";
import Content from "../components/ContentHeader.js";
import Route from "../components/Route.js";

// css
import "../css/Partners.css";

function Partners() {
  const [data, setData] = useState([]);
  // console.log(data);

  const handleLoad = async () => {
    const result = await getPartners();
    setData(result);
  };

  useEffect(() => {
    handleLoad();
  }, []);
  return (
    <div className="partners_wrap">
      <ScrollTop />

      <Content title="PARTNERS"></Content>

      <Route route1="PARTNERS"></Route>
      <div className="content_bg">
        <h1>레인보우브레인의 파트너사 | 생성형 AI · RPA 협력 네트워크</h1>
        <div className="container">
          <div className="partners_box">
            {data.length > 0 && (
              <div
                className="partners_cont"
                dangerouslySetInnerHTML={{ __html: data[0].content }}
              ></div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Partners;
